import script from "./AutomationDropList.vue?vue&type=script&setup=true&lang=js"
export * from "./AutomationDropList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import DropTable from "@/components/neue/DropTable.vue";
import NeueWell from "@/components/neue/NeueWell.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
script.components = Object.assign({}, { DropTable, NeueWell, SecondaryNav, SecondaryTop }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { DropTable, NeueWell, SecondaryNav, SecondaryTop }, script.__o.components);}